import { component } from "picoapp";
import { handleize } from "../../../../scripts/lib/utils";
import { type Context, type SelectedVariant } from "../../../state";

const updateSectionVisibility = ({
  node,
  titleHandle,
  variant,
}: {
  node: HTMLElement;
  titleHandle: string;
  variant: SelectedVariant;
}) => {
  if (handleize(variant?.title) === titleHandle) {
    node.classList.remove("hidden");
  } else {
    node.classList.add("hidden");
  }
};

const handleSectionVisibility = (node: HTMLElement, context: Context) => {
  const variantVisibleTitleHandle = node?.dataset?.variantVisibleTitleHandle;
  if (variantVisibleTitleHandle) {
    context.on("tbsp:variant-selected", ({ selectedVariant }) => {
      updateSectionVisibility({
        node,
        titleHandle: variantVisibleTitleHandle,
        variant: selectedVariant,
      });
    });
  }
};

export const ensureAutoplay = (node: HTMLElement): void => {
  const video = node.querySelector<HTMLVideoElement>("video[autoplay]");
  if (!video) {
    return;
  }

  const attemptPlay = () => {
    if (video.paused) {
      video.muted = true;
      void video.play().catch(() => {});
    }
  };

  if (video.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA) {
    attemptPlay();
  } else {
    video.addEventListener("canplay", attemptPlay, { once: true });
  }
};

export const fullScreenHero = component<Context>(
  (node: HTMLElement, context: Context) => {
    handleSectionVisibility(node, context);
    ensureAutoplay(node);
  }
);

export const splitScreenHero = component<Context>(
  (node: HTMLElement, context: Context) => {
    handleSectionVisibility(node, context);
    ensureAutoplay(node);
  }
);
